<template lang="pug">
  .column.is-12
    ModalPrograma(:config="configModal" @modalEvent="modificarPrograma" v-show="verModal")
    ModalIdPrograma(:config="configModalIdPrograma" @modalEvent="modificarIdPrograma" v-show="verModalIdPrograma")
    ModalPeso(:config="configModalPeso" @modalEvent="modificarPeso" v-show="verModalPeso")
    ModalSello(:config="configModalSello" @modalEvent="modificarPeso" v-show="verModalSello")
    ModalEdit(:config="configModalEdit" @modalEvent="modificarSolicitudEdit" v-show="verModalEdit")
    ModalSubgrupo(:config="configModalSubgrupo" :subgrupos="grupos" @modalEvent="modificarSubgrupo" v-show="verModalSubgrupo")
    ModalYesNo(:config="configModalYesNo" @modalEvent="confirmarBorrado" v-show="verModalEliminar" @saveData="saveData")
    TbLlegando(
      v-show="!verPesoNeto"
      :autotanques="autotanques"
      :nominaciones="nominaciones"
      @cambiarPrograma="cambiarPrograma"
      @cambiarPesoEntrada="cambiarPesoEntrada"
      @cambiarPesoSalida="cambiarPesoSalida"
      @cambiarMagnatel="cambiarMagnatel"
      @cambiarPresion="cambiarPresion"
      @agregarSello="agregarSello"
      @borrarSello="borrarSello"
      @cambiarGrupo="cambiarGrupo"
      @cambiarNomCar="cambiarNomCar"
      @eliminarAutotanque="eliminarAutotanque"
      @solicitudEditar="solicitudEditar"
      )
    TbLlegandoPesoNeto(
      v-show="verPesoNeto"
      :autotanques="autotanques"
      :nominaciones="nominaciones"
      @cambiarPrograma="cambiarPrograma"
      @cambiarPesoEntrada="cambiarPesoEntrada"
      @cambiarPesoSalida="cambiarPesoSalida"
      @cambiarMagnatel="cambiarMagnatel"
      @cambiarPresion="cambiarPresion"
      @agregarSello="agregarSello"
      @borrarSello="borrarSello"
      @cambiarGrupo="cambiarGrupo"
      @solicitudEditar="solicitudEditar"
      )
</template>

<script>
  import TbLlegando from './TbLlegando.vue'
  import TbLlegandoPesoNeto from './TbLlegandoPesoNeto.vue'
  import ModalPrograma from './ModalPrograma.vue'
  import ModalIdPrograma from './ModalIdPrograma.vue'
  import ModalPeso from './ModalPeso.vue'
  import ModalSello from './ModalSello.vue'
  import ModalEdit from './ModalEdit.vue'
  import ModalSubgrupo from './ModalSubgrupo.vue'
  import ModalYesNo from './ModalYesNo.vue'
  import accesos_tpaServices from '@/services/sca/accesos/accesosTPA.js'
  import moment from 'moment'
  import { mapState } from 'vuex'
  import api_ducter_energy from '@/services/sca/apiDucterEnergy.js'
  import sca_tuxpanServices from '@/services/sca/tpa.js'

  export default {
    name: 'ContainerAutotanques',
    components: { TbLlegando, TbLlegandoPesoNeto, ModalPrograma, ModalIdPrograma, ModalPeso, ModalSubgrupo, ModalSello, ModalYesNo, ModalEdit },
    props: {
      autotanques: {
        type: Array,
        default: () => []
      },
      nominaciones: {
        type: Array,
        default: () => []
      },
      grupos: {
        type: Array,
        default: () => []
      },
      verPesoNeto: {
        type: Boolean,
        default: false,
      },
      sca_sellosCL: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        verModal: false,
        verModalIdPrograma: false,
        verModalPeso: false,
        verModalSubgrupo: false,
        verModalSello: false,
        verModalEdit: false,
        verModalEliminar: false,
        configModal: {},
        configModalIdPrograma: {},
        configModalPeso: {},
        configModalSello: {},
        configModalEdit: {},
        configModalSubgrupo: {},
        configModalYesNo: {},
        datoRegistrando: '',
        accesoSel: {},
        accesoSeleccionado: {},
        pgEliminar: '',
        cambiosRealizados: '',
      }
    },
    methods: {
      cambiarPrograma (prog) {
        this.accesoSel = prog
        this.configModal = {
          title: 'Cambiar el Programa del Tanque',
          content: prog.programa == 0 ? '¿Desea agregar el programa del autotanque?' : '¿Desea quitar el programa del autotanque?',
          textCancel: 'Cancelar',
          textOk: 'Aceptar'
        }
        this.verModal = true
      },

      modificarPrograma (res) {
        if (res) {
          accesos_tpaServices.updateAcceso_Programa(this.accesoSel.id, this.accesoSel.programa ? 0 : 1)
            .then( data => {
              this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
              this.$emit('updateAutanques', true)
              this.$emit('eventLoading', false)
              this.verModal = false
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          this.$emit('eventLoading', res)
          this.verModal = false
        }
      },

      modificarIdPrograma (res) {
        console.log("🚀 ~ modificarIdPrograma ~ res:", res)

        if (res) {
          this.$emit('eventLoading', false)
          this.verModalIdPrograma = false
          accesos_tpaServices.updateAcceso_IDPrograma(this.accesoSel.id, res.valor)
            .then( data => {
              this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
              this.$emit('updateAutanques', true)
              this.$emit('eventLoading', false)
              this.verModalIdPrograma = false
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          this.$emit('eventLoading', res)
          this.verModalIdPrograma = false
        }
      },

      modificarSubgrupo (res) {
        if (res.save) {
          accesos_tpaServices.updateAcceso_Subgrupo(this.accesoSel.claveAcceso, res.grupo)
            .then( data => {
              this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
              this.$emit('updateAutanques', true)
              this.$emit('eventLoading', false)
              this.verModalSubgrupo = false
            })
            .catch(e => {
              this.isLoading = false
              this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
            })
        } else {
          this.$emit('eventLoading', res.save)
          this.verModalSubgrupo = false
        }
      },

      cambiarPesoEntrada (data) {
        this.accesoSel = data
        this.configModalPeso = {
          title: 'Registrar Peso de Entrada',
          content: 'Registre el peso de entrada.',
          question: 'Peso de Entrada',
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.datoRegistrando = 'e'
        this.verModalPeso = true

      },

      cambiarPesoSalida (data) {
        this.accesoSel = data
        this.configModalPeso = {
          title: 'Registrar Peso de Salida',
          content: 'Registre el peso de Salida.',
          question: 'Peso de Salida',
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.datoRegistrando = 's'
        this.verModalPeso = true
      },

      cambiarMagnatel (data) {
        this.accesoSel = data
        this.configModalPeso = {
          title: 'Registrar el Magnatel',
          content: 'Registre el magnatel del autotanque.',
          question: 'Magnatel',
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.datoRegistrando = 'm'
        this.verModalPeso = true
      },

      cambiarPresion (data) {
        this.accesoSel = data
        this.configModalPeso = {
          title: 'Registrar la presión del autotanque',
          content: 'Registre la presión del autotanque.',
          question: 'Presión',
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.datoRegistrando = 'p'
        this.verModalPeso = true
      },

      agregarSello (data) {
        this.accesoSel = data
        this.datoRegistrando = 'se'
        if (this.sca_sellosCL) {
          this.configModalSello = {
            title: 'Registrar sello del autotanque',
            content: 'Registre el sello del autotanque.',
            question: 'Sello',
            textCancel: 'Cancelar',
            textOk: 'Guardar'
          }
          this.verModalSello = true
        } else {
          this.configModalPeso = {
            title: 'Registrar sello del autotanque',
            content: 'Registre el sello del autotanque.',
            question: 'Sello',
            textCancel: 'Cancelar',
            textOk: 'Guardar'
          }
          this.verModalPeso = true
        }
      },

     solicitudEditar (data) {
        console.log(data)
        this.accesoSel = data
          this.configModalEdit = {
            title: 'Autorizar solicitud de edición',
            content: '¿Estas seguro de autorizar edición del '+data.pg+'?',
            question: '¿Estas seguro de autorizar edición?',
            textCancel: 'No',
            textOk: 'Si',
            emb:data
          }
          this.verModalEdit = true
      },

      cambiarGrupo (data) {
        this.accesoSel = data
        this.configModalSubgrupo = {
          title: 'Registrar Grupo',
          content: 'Registre el grupo del autotanque.',
          question: 'Grupo',
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.verModalSubgrupo = true
      },

      cambiarNomCar (data) {
        this.accesoSel = data
        this.configModalIdPrograma = {
          title: 'Registrar Id Nomcar',
          content: 'Registre el id de nominación de NOMCAR.',
          question: 'Id Nomicación',
          textCancel: 'Cancelar',
          textOk: 'Guardar'
        }
        this.verModalIdPrograma = true
      },

      async modificarPeso(obj) {
        if (obj.save) {
          const fecha_hora = moment().format('YYYY-MM-DD HH:mm:ss')
          console.log("🚀 ~ file: ContainerAutotanques.vue:257 ~ modificarPeso ~ this.accesoSel:", this.accesoSel)

          switch (this.datoRegistrando) {
            case 'e':
              // Enviar evento de actualizar autotanque | En báscula
              await accesos_tpaServices.updateAcceso_PesoE(this.accesoSel.claveAcceso, obj.valor)
                .then( async (data) => {
                  this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                  this.$emit('updateAutanques', true)
                  this.$emit('eventLoading', false)

                  const pgs = this.autotanques.filter( at => at.claveAcceso === this.accesoSel.claveAcceso)
                  console.log("🚀 ~ file: ContainerAutotanques.vue:244 ~ .then ~ pgs:", pgs)

                  pgs.forEach( async (pg) => {
                    console.log("🚀 ~ file: ContainerAutotanques.vue:247 ~ pg.forEach ~ pg:", pg)
                    if (pg.id_programa > 0) {
                      const dataEnergy = {
                        pg: pg.pg,
                        program_id: pg.id_programa,
                        status: {
                          event: "En patio",
                          event_code: 5002,
                          event_date: fecha_hora,
                        }
                      }
                      await api_ducter_energy.updateProgram(dataEnergy)
                        .then( response => { console.log(response)})
                        .catch( e => console.log(e))
                    }
                  })
                  this.verModal = false
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })
                this.verModalPeso = false
              break
            case 's':
              accesos_tpaServices.updateAcceso_PesoS(this.accesoSel.claveAcceso, obj.valor)
                .then( async (data) => {
                  this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                  this.$emit('updateAutanques', true)
                  this.$emit('eventLoading', false)

                  // Enviar evento de actualizar autotanque | Para documentar
                  const pgs = this.autotanques.filter( at => at.claveAcceso === this.accesoSel.claveAcceso)
                  console.log("🚀 ~ file: ContainerAutotanques.vue:244 ~ .then ~ pgs:", pgs)

                  pgs.forEach( async (pg) => {
                    console.log("🚀 ~ file: ContainerAutotanques.vue:247 ~ pg.forEach ~ pg:", pg)
                    if (pg.id_programa > 0) {
                      const dataEnergy = {
                        pg: pg.pg,
                        program_id: pg.id_programa,
                        status: {
                          event: "Documentando",
                          event_code: 5004,
                          event_date: fecha_hora,
                        }
                      }
                      await api_ducter_energy.updateProgram(dataEnergy)
                        .then( response => { console.log(response)})
                        .catch( e => console.log(e))
                    }
                  })
                  this.verModal = false
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })
                this.verModalPeso = false
              break
            case 'm':
              accesos_tpaServices.updateAcceso_Magnatel(this.accesoSel.id, obj.valor)
                .then( data => {
                  this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                  this.$emit('updateAutanques', true)
                  this.$emit('eventLoading', false)
                  this.verModal = false
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })
                this.verModalPeso = false
              break
            case 'p':
              accesos_tpaServices.updateAcceso_Presion(this.accesoSel.id, obj.valor)
                .then( data => {
                  this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                  this.$emit('updateAutanques', true)
                  this.$emit('eventLoading', false)
                  this.verModal = false
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })
                this.verModalPeso = false
              break
            case 'se':
              const tipoSello = this.sca_sellosCL ? obj.tipo : 1
              accesos_tpaServices.addAcceso_Sello(this.accesoSel.id, obj.valor, tipoSello)
                .then( data => {
                  this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
                  this.$emit('updateAutanques', true)
                  this.$emit('eventLoading', false)
                  this.verModalSello = false
                })
                .catch(e => {
                  this.isLoading = false
                  this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
                })
                this.verModalPeso = false
              break
            default:
              break
          }
        } else {
          this.isLoading = false
          this.verModalPeso = false
          this.verModalSello = false
        }
      },
      async modificarSolicitudEdit(obj) {
        console.log(obj)
        if(obj.save){
          await sca_tuxpanServices.updatePermisoEditar(obj.valor.idEntrada,2,2)
          .then((data) => {
            this.displayToast(data.respuesta, 'check', 'Ok')
          })
          .catch(e => {
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
          this.$emit('updateAutanques', true)
          this.$emit('eventLoading', false)
        }else{
          await sca_tuxpanServices.updatePermisoEditar(obj.valor.idEntrada,0,3)
          .then((data) => {
            this.displayToast(data.respuesta, 'check', 'Ok')
          })
          .catch(e => {
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
          this.$emit('updateAutanques', true)
          this.$emit('eventLoading', false)


        }
        this.verModalEdit = false
      },

      borrarSello (data) {
        this.isLoading = true
        accesos_tpaServices.deleteAcceso_Sello(data.id)
          .then( data => {
            this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
            this.$emit('updateAutanques', true)
            this.$emit('eventLoading', false)
          })
          .catch(e => {
            this.isLoading = false
            this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
          })
      },

      displayToast(text, icon, actionText) {
        let toast = this.$toasted.show(text, {
          theme: "toasted-primary",
          position: "bottom-right",
          duration : 2000,
          iconPack: 'fontawesome',
          icon: icon,
          action : {
            text : actionText,
            onClick : (e, toastObject) => {
              toastObject.goAway(0)
            }
          },
        })
      },

      showMdal (val) {
        this.verModal = val
      },

      eliminarAutotanque(data){
        this.pgEliminar = data.pg
        this.configModalYesNo = {
          title: 'Eliminar Acceso',
          content:'¿Desea eliminar éste acceso definitivamente?',
        }
        this.verModalEliminar = true
        this.accesoSeleccionado = data.id
      },

      saveData(data){
        let ahora = moment().format('hh:mm:ss')
        if(data == true){
          this.cambiosRealizados =  `Confirmó eliminación de acceso con PG: ${this.pgEliminar}. Hora: ${ahora}`
          this.confirmarBorrado(this.accesoSeleccionado, 4, this.cambiosRealizados)
        } else if(data == 'return'){
          this.cambiosRealizados =  `Rechazó la eliminación de acceso con PG: ${this.pgEliminar}, el registro nuevamente se añadió a accesos. Hora: ${ahora}`
          this.confirmarBorrado(this.accesoSeleccionado, 1, this.cambiosRealizados)
        }else{
          this.verModalEliminar = false
        }
      },

      confirmarBorrado(id,estado, motivos){
      accesos_tpaServices.deleteAutotanque(id,estado)
          .then( data => {
            this.displayToast(data.respuesta, data.success ? 'check' : 'ban', 'Ok')
            this.$emit('updateAutanques', true)
            this.$emit('eventLoading', false)
            this.verModalEliminar = false
            this.registrarMovimientos(motivos)
          })
        .catch(e => {
          this.isLoading = false
          this.displayToast(`Error: ${e.message}`, 'ban', 'OK')
        })
      },

      registrarMovimientos(cambios){
        accesos_tpaServices.addEdicion('N/A', moment().format('YYYY-MM-DD'), this.userLogin.nombre, cambios, 'Respuesta a eliminación de acceso')
          .then( data => {
            console.log('Cambios registrados')
          })
          .catch( e => {
            this.displayToast('bubble', `Error: ${e.message}`, 'ban', 'Ok')
            this.isLoading = false
          })
      },

    }, computed:{ ...mapState(['userLogin']) }
  }
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/sca_Componentes/tpa/cuartocontrol/componentes/ContainerAutotanques.vue